import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'
import type { IProjectParticipant } from '../../../Model/Project/IProjectParticipant.js'

export const UpdateParticipantEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.updateParticipantRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return ProjectRepository.updateParticipant(action.payload.projectId, action.payload.participantId, {
        mayEdit: action.payload.mayEdit,
        version: action.payload.version
      }).pipe(
        mergeMap((response: IProjectParticipant) => {
          // Assuming the API returns the newly added note as the last item in the array
          return of(
            project.updateParticipantRequestSuccess({
              projectId: action.payload.projectId,
              participant: response
            })
          )
        }),
        catchError((error) => of(project.updateParticipantRequestFailure({ error })))
      )
    })
  )
